import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {
  alabaster,
  darkGray,
  denim,
  grayscale,
  white,
} from '/theme/color/on.color';
import {alto, codGray, graniteGray} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    paddingTop: 0,
    paddingHorizontal: indent * 0.35,
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: indent * 0.4,
    paddingLeft: indent * 0.3,
    paddingBottom: indent * 0.8,
  },
  linksIconLabel: {
    flexDirection: 'column',
  },
  taskItemContainer: {
    flexDirection: 'row',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    paddingLeft: indent,
    paddingVertical: indent * 0.6,
  },
  enabledContainer: {
    backgroundColor: alabaster,
    borderColor: white,
  },
  disabledContainer: {
    backgroundColor: white,
    borderColor: alto,
  },
  itemSelectedText: {
    fontWeight: '600',
    color: darkGray,
  },
  itemDisabledText: {
    fontWeight: '600',
    color: graniteGray,
  },
  // @ts-expect-error TS(2322): Type '{ color: string; fontFamily: string; fontWei... Remove this comment to see the full error message
  itemUnSelectedText: {
    ...getFontFamily('bold'),
    color: codGray,
  },
  iconContainer: {
    width: 22,
    height: 22,
    marginHorizontal: indent * 0.25,
    marginTop: indent * 0.4,
    marginRight: indent * 0.4,
  },
  selectedIcon: {
    fontSize: 22,
    color: denim,
  },
  unSelectedIcon: {
    fontSize: 22,
    borderColor: grayscale,
    borderStyle: 'solid',
    borderWidth: 2.5,
    borderRadius: 2,
    color: white,
  },
  disabledIcon: {
    fontSize: 22,
    color: white,
    borderStyle: 'solid',
    borderWidth: 2.5,
    borderRadius: 2,
    borderColor: grayscale,
  },
  iconColumn: {
    fontSize: 16,
    marginRight: 4,
    color: grayscale,
  },
  socialText: {
    fontSize: 16,
    color: codGray,
    fontWeight: '600',
    paddingRight: indent * 1,
  },
  linkContainer: {
    marginBottom: indent * 0.7,
  },
  urlText: {
    paddingTop: indent * 0.1,
    marginLeft: indent * 0.2,
  },
  iconAndLabelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
